// extracted by mini-css-extract-plugin
export var completionBody = "_c8-2";
export var completionCard = "_c8-0";
export var completionFooter = "_c8-3";
export var completionTitle = "_c8-1";